/**
 * Supported player types.
 */
export enum MKPlayerType {
    /**
     * The MediaSource Extension (MSE) based JavaScript player.
     */
    Html5 = "html5",

    /**
     * The browser's native capabilities are being used, e.g. playing back HLS in Safari on iOS.
     */
    Native = "native",

    /**
     * WebRTC player.
     */
    WebRtc = "webrtc",

    /**
     * The initial value where it is not known yet which player will be used.
     */
    Unknown = "unknown"
}